import React from 'react';
import Icon from '@omilia/icon';

import { getThemeProp, theme } from 'theme';

import Button from 'components/Button';
import CommonModal from 'components/CommonModal';
// @ts-ignore
import Divider, { dividerAbsolutePositionStyles } from 'components/Divider';
import {
  SCommonModalFooter,
  SCommonModalHeader,
  SCommonModalHeaderTextContainer,
  SVerticalLine,
} from './styled';

type Props = {
  onCancel: () => void;
  onUpload: () => void;
  onBack: () => void;
};

const ModalWithConflicts = ({ onCancel, onUpload, onBack }: Props) => (
  <CommonModal
    isOpen
    body={
      <div>
        <span
          css={`
            color: ${getThemeProp('colors.danger')};
          `}
        >
          Warning
        </span>
        : Duplicate files have been detected. All duplicate files will be
        replaced accordingly, while all new files will be appending. Replacing
        cannot be undone. Are you sure you want to continue?
      </div>
    }
    footer={
      <SCommonModalFooter>
        <Button
          isLarge
          isTransparent
          css={`
            && {
              margin-right: unset;
            }
          `}
          data-test="cancel-button"
          onClick={onCancel}
        >
          Cancel
        </Button>

        <Button
          isLarge
          data-test="upload-and-replace-button"
          onClick={onUpload}
        >
          Upload & Replace
        </Button>
      </SCommonModalFooter>
    }
    header={
      <SCommonModalHeader>
        <Icon
          data-test="go-back-button"
          glyph="arrow-left"
          primaryColor={theme.colors.moodyBlue2}
          size="18"
          onClick={onBack}
        />
        <SVerticalLine />
        <Icon
          glyph="notification-warning"
          primaryColor={theme.colors.danger}
          size="24"
        />
        <SCommonModalHeaderTextContainer data-test="warning-title">
          Duplicate files found!
        </SCommonModalHeaderTextContainer>

        <Divider css={dividerAbsolutePositionStyles} />
      </SCommonModalHeader>
    }
  />
);

export default ModalWithConflicts;
